import { Children, cloneElement, isValidElement, type ReactNode } from 'react';

type FormControlProps = { children: ReactNode } & Record<string, unknown>;

export const FormControl = ({ children, ...props }: FormControlProps) => {
  return Children.map(children, (child) => {
    if (isValidElement(child)) {
      return cloneElement(child, {
        ...(child.props as Record<string, unknown>),
        ...(props as Record<string, unknown>),
      });
    }
    return child;
  });
};

FormControl.displayName = 'Form.Control';
